export default __webpack_public_path__ + "static/media/1977.76fca048.png";